

const Global_var = {
    //live_server: 'http://192.168.0.193:3002',/*change this IP to your server IP adress. keep 3002 PORT or change PORT const at ./server */
    live_server: 'https://lapmonitor.live',/*change this IP to your server IP adress. keep 3002 PORT or change PORT const at ./server */
}

export default Global_var


//martin desktop: 192.168.0.193
//steph desktop: 192.168.0.12
//
//
